import {
    type BooleanScaleData,
    type CycleScaleData,
    DEFAULT_TEMP,
    type MealScaleData,
    type MoodScaleData,
    type NoneScaleData,
    type OvulationScaleData,
    type ScaleData,
    type SexScaleData,
    type SleepScaleData,
    type TemperatureScaleData,
    type TenScaleData,
    type ThirtyScaleData,
    type TwentyScaleData,
    type WaterScaleData,
} from "@qendo/profile/journal";
import { ScaleType, WaterVolume } from "@qendo/trackables";

export function makeNewScale<S extends ScaleType>(type: S): ScaleData<S> {
    switch (type) {
        case ScaleType.none:
            return { type } as NoneScaleData & ScaleData<S>;
        case ScaleType.boolean:
            return { type, value: false } as BooleanScaleData & ScaleData<S>;
        case ScaleType.water:
            return { type, value: null, volume: WaterVolume.litre } as WaterScaleData & ScaleData<S>;
        case ScaleType.mood:
            return { type, value: null, feelings: [] as string[] } as MoodScaleData & ScaleData<S>;
        case ScaleType.ovulation:
            return {
                type,
                value: null,
                mucus: false,
                basal: false,
                breast: false,
                headache: false,
            } as OvulationScaleData & ScaleData<S>;
        case ScaleType.sleep:
            return { type, value: null, start: null, end: null } as SleepScaleData & ScaleData<S>;
        case ScaleType.temperature:
            return { type, value: DEFAULT_TEMP } as TemperatureScaleData & ScaleData<S>;
        default:
            return {
                type,
                value: null,
            } as ScaleData<S> &
                (CycleScaleData | MealScaleData | SexScaleData | TenScaleData | TwentyScaleData | ThirtyScaleData);
    }
}
